import { Markets } from '@/v2/v3/Markets'

// Default export — App.jsx imports it both as `Discover` and as
// `V2DiscoverPage` (App.jsx routes /discover → V2DiscoverPage). /discover
// lands on the consolidated Markets screen (the Universe leaderboard +
// map — the tab-consolidation pass). Markets brings its own v3 shell +
// StockDetailProvider — no AppLayout wrapper here. The old
// DiscoverInner/useHuntingExtraStocks legacy body was trimmed in the B4
// cleanup — see git history.
export function Discover() {
  return <Markets />
}

export default Discover
